<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>Users Profile Change Report</h1>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <form>
        <div class="row" *ngIf="saveSuccess">
            <div class="col-24">
                <div class="alert success">
                    <p><em>Thank you!</em></p>
                    <ul>
                        <li>
                            <p>{{saveSuccess}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <label>Start Date</label>
                    <JQDatePicker (elementClicked)="searchModel.StartDate = $event" [selectedDate]="searchModel.StartDate">
                    </JQDatePicker>

                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <label>End Date</label>
                    <JQDatePicker (elementClicked)="searchModel.EndDate = $event" [selectedDate]="searchModel.EndDate">
                    </JQDatePicker>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="GetUserSearchData(searchModel)">Search</button>
            </div>
        </div>
        <!--<div class="row">
            <div class="col-24">
                <button class="button primary" (click)="ExportToExcel()">Export to excel</button>
            </div>
        </div>-->
    </form>
    <div [hidden]="!showUsersSearch">
        <div class="row">
            <div class="col-24">
                <div class="bottom-10">
                    <button id="btnExport" class="button link excel" (click)="ExportToExcel()">Export to Excel</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <div class="jqgrid-header-wrap">
                        <jqxGrid [width]="1240"
                        [virtualmode]="true"
                        [rendergridrows]="renderPortalGridRows"
                        [source]="dataAdapter"
                        [columns]="columns"
                        [pageable]="true"
                        [pagesizeoptions]="[20, 50, 100]"
                        [pagesize]="50"
                        [sortable]="true"
                        (onSort)="onSortPortal($event)"
                        [autoshowcolumnsmenubutton]="false"
                        [editable]="true"
                        (onPagesizechanged)="onPortalPageSizeChanged($event)"
                        [filterable]="true"
                        [columnsresize]="true"
                        [ready]="ready"
                        [selectionmode]="'multiplecellsadvanced'"
                        [updatefilterconditions]="updatefilterconditions" (onFilter)="onFilter($event)"
                        #usersearchgrid>
                        </jqxGrid>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [hidden]="showUsersSearch">
        {{message}}
    </div>

</div>
